import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthManager } from "services/auth-service/auth";
import { useAppDispatch } from "store";
import { sandboxActionCompleted } from "store/features";
import { Avatar, Button, Dialog, Tile } from "@itwin/itwinui-react";
import styles from "./RequireSigninActionHandler.module.css";

export const RequireSigninActionHandler = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  const onSignIn = () => {
    AuthManager.signIn({ redirect: location.pathname });
    onClose();
  }

  const onClose = () => {
    setIsModalOpen(false);
    setTimeout(() => dispatch(sandboxActionCompleted()), 200);
  };

  useEffect(() => {
    setTimeout(() => setIsModalOpen(true), 5);
  }, []);

  return (
    <Dialog isOpen={isModalOpen} onClose={onClose} closeOnEsc closeOnExternalClick preventDocumentScroll trapFocus setFocus isDismissible>
      <Dialog.Backdrop />
      <Dialog.Main>
        <Dialog.TitleBar titleText="Sign-in to Continue" />
        <Dialog.Content>
          <Tile
            className={styles.tile}
            name={null}
            thumbnail={
              <Avatar
                size="x-large"
                image={<img src="https://itwinplatformcdn.azureedge.net/iTwinUI/user-placeholder.png" />}
              />
            }>
          </Tile>
        </Dialog.Content>
        <Dialog.ButtonBar>
          <Button styleType="high-visibility" onClick={onSignIn}>Sign In</Button>
          <Button onClick={onClose}>Close</Button>
        </Dialog.ButtonBar>
      </Dialog.Main>
    </Dialog>
  )
}
